import type { ColorScheme } from '../../types'

/**
 * Colour for validation errors — field borders, warning text and inline
 * messages.
 *
 * The dark scheme resolves the `status.error` token. The light scheme returns
 * a literal because `light.status.error` is `#DC2626`, a different red from the
 * `#C0392B` the form controls have shipped since the first rebrand PRs;
 * swapping it here would restyle every existing error state. Kept in one place
 * so that decision is made once, with design, rather than per component.
 */
export const errorColorFor = (colorScheme: ColorScheme): string =>
  colorScheme === 'light' ? '#C0392B' : 'status.error'
